/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getContactAliases} from '../api'

 export const useQueryGetContactAliases = createReactQueryHook('getContactAliases', getContactAliases)
